export default defineNuxtPlugin((nuxtApp) => {
	return {
		provide: {
			en: {
				leads: {
					searchTooltipDescription:
						'Search leads by first name, last name, email address, phone number, post code, lead category and description.',
				},
				contacts: {
					searchTooltipDescription:
						'Search prospects by first name, last name, email address, phone number, address and post code.',
					searchSelectPlaceholder: 'Search by first & last name, email, phone number and address',
				},
				deals: {
					searchTooltipDescription: 'Search deals by name, contact name, address, email or phone number.',
				},
				events: {
					searchPlaceholder: 'Search calendar',
				},
				crm: {
					funds: (link) =>
						'<p class="text-left">Refill your balance to use this feature: <a href="'+link+'" class="link-text">Refill now</a></p>',
					plus: 'Requires CRM Plus package',
					pro: 'Requires CRM Pro package',
				},

				default: {
					searchTooltipDescription: '',
					searchPlaceholder: null,
				},
			},
		},
	}
})
